import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getCurrentStorageUser } from '../../common/localStorage/currentStorageUser'

export const useMarketingTextsStore = defineStore('marketingTexts', () => {
    const allMarketingTexts = ref([])

    const setAllMarketingTexts = (marketingTexts) => {
        allMarketingTexts.value = marketingTexts
        persistToLocalStorage()
    }

    const findById = (id) => allMarketingTexts.value.find((m) => m.id == id)

    const getPiniaStorageKey = () => {
        return getCurrentStorageUser() + '@pinia'
    }

    const persistToLocalStorage = () => {
        const key = getPiniaStorageKey()
        try {
            let data = {}
            const stored = localStorage.getItem(key)
            if (stored) {
                try {
                    data = JSON.parse(stored)
                } catch (e) {
                    console.warn('Failed to parse existing Pinia localStorage, creating new:', e)
                    data = {}
                }
            }

            data.marketingTextsStore = {
                allMarketingTexts: allMarketingTexts.value,
            }

            localStorage.setItem(key, JSON.stringify(data))
        } catch (e) {
            if (e.name === 'QuotaExceededError' || e.message.includes('quota')) {
                console.warn('QuotaExceededError detected in marketing texts store')
                throw e
            }
        }
    }

    const loadFromLocalStorage = () => {
        const key = getPiniaStorageKey()
        try {
            const stored = localStorage.getItem(key)
            if (stored) {
                const data = JSON.parse(stored)
                if (data.marketingTextsStore && Array.isArray(data.marketingTextsStore.allMarketingTexts)) {
                    allMarketingTexts.value = data.marketingTextsStore.allMarketingTexts
                }
            }
        } catch (e) {
            console.warn('Failed to load marketing texts from localStorage:', e)
        }
    }

    loadFromLocalStorage()

    return {
        allMarketingTexts,
        setAllMarketingTexts,
        findById,
    }
})